import styled from 'styled-components';

export const Content = styled.p`
  margin: 1.5rem 0;
`;
